import { Inject } from '@odinjs/odin';

import './provider-accreditation-clinical-staff.scss';

import { Endpoint, Route } from '@philips-emr/hpms-provider-accreditation-commons';
import { FetchAPI } from '@philips-emr/tws-components';
import Controller, { OnBeforeSubmit, OnClick, OnEdit, OnMount } from '@philips-emr/tws-core/lib/client';
import { EditEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService } from '@philips-emr/tws-core/lib/services';

import BaseController from '../BaseController';

interface Target {
  state: State;
}
interface State {
  oldValues: Record<string, Value>;
  data: Record<string, Value>;
}
interface FieldTypes {
  nmAtributo: string;
  dsValorOld: string | Value;
  dsValorNew: string | Value;
  nrSequencia: string;
}

interface Value {
  nmContato: string,
  nrTelefone: string
}

@Controller({ fragment: 'personal-contact' })
export default class ProviderAccreditationClinicalStaffController extends BaseController {

  state: State = { oldValues: {}, data: {} };

  @Inject('fetch-clinical-staff')
  private fetch: FetchAPI;

  @OnClick('action-new-clinical-staff')
  onClickNewInclusion(): void {
    this.historyService.push(Route.MY_DATA);
  }

  @OnMount('panel-clinical-staff')
  onMountPanel(): void {
    const { nrSeqAccreditation } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqAccreditation: nrSeqAccreditation });
    this.fetch.forceFetch();
  }

  @OnEdit('form-additional')
  onEdit(event: EditEvent): void {
    const target = event.target as unknown as Target;
    this.state.oldValues = target.state.data;
  }

  @OnBeforeSubmit('form-additional')
  onBeforeSubmit(event: Event): void {
    const campos: FieldTypes[] = [];
    const insertVal: Record<string, Value>[] = [];
    const target = event.target as unknown as Target;
    const newValues = target.state.data;
    const oldValues = this.state.oldValues;
    const body = { campos, insertVal };

    Object.keys(newValues).forEach(key => {
      if (oldValues && oldValues[key] != newValues[key] && newValues.nrSequencia != null) {
        const oldV = oldValues[key];
        const newV = newValues[key];
        body.campos.push({
          nmAtributo: key,
          dsValorOld: oldV ? oldV.nmContato || oldV.nrTelefone || oldV : '',
          dsValorNew: newV ? newV.nmContato || newV.nrTelefone || newV : '',
          nrSequencia: '1',
        });
      }
    });

    if (newValues.nrSequencia == null) {
      body.insertVal.push(newValues);
    }

    void HttpService.post(Endpoint.POST.QUESTIONNAIRE_METADATA, {}, { body }).then((response) => {
      console.log(response);
    });
  }
}
